import React, { useState } from "react";
import "./styles.scss";
import { BiGridVertical } from "react-icons/bi";

import { ProgressBar } from "react-bootstrap";
import { MdCheck, MdClose } from "react-icons/md";
import { FaPencilAlt } from "react-icons/fa";
import {
  useWorkShop,
  WorkshopSectionContent,
  WorkshopSectionContentType,
} from "../../../../../../contexts/workshop-context/WorkshopContext";
import { RiDeleteBin5Line } from "react-icons/ri";
import { DraggableProvided } from "react-beautiful-dnd";

export interface MediaFileContent {
  fileName: string;
  type:
    | "xls"
    | "pptx"
    | "ppt"
    | "pdf"
    | "docx"
    | "doc"
    | "xlsx"
    | "txt"
    | "md"
    | "all";
  url: string;
}

interface IProps {
  children: any;
  resource: WorkshopSectionContent;
  provided: DraggableProvided;
  fileNotSelected?: boolean;
  uploading?: boolean;
  updateCurrentAction: (
    isEditing: boolean,
    isUploading: boolean,
    allowNavigation: boolean
  ) => void;
  onUploading?(status: boolean): void;
}

const MediaCard = (props: IProps) => {
  const workshop = useWorkShop();
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const activePreviewMode = (resource: WorkshopSectionContent) => {
    if (
      resource.type === WorkshopSectionContentType.IMAGE_URL ||
      resource.type === WorkshopSectionContentType.FILE_URL ||
      resource.type === WorkshopSectionContentType.VIDEO_URL
    ) {
      setLoading(true);
      props.onUploading && props.onUploading(true);
      workshop.uploadResource(
        workshop.selectedSubSection,
        { ...resource, mode: "PREVIEW" },
        () => {
          setLoading(false);
          props.onUploading && props.onUploading(false);
        },
        () => {
          setLoading(false);
          props.onUploading && props.onUploading(false);
        },
        (value) => {
          setUploadProgress(value);
        }
      );
    } else {
      workshop.updateResource(workshop.selectedSubSection, {
        ...props.resource,
        mode: "PREVIEW",
      });
    }
  };

  return (
    <div className="media-card">
      {loading && (
        <div className="loader">
          <label>Uploading {uploadProgress}%</label>
          <ProgressBar animated now={uploadProgress} className="prograssbar" />
        </div>
      )}
      <div className="flex-container">
        <div className="move-icon" {...props.provided.dragHandleProps}>
          <BiGridVertical />
        </div>
        <div className="media-content">{props.children}</div>
        <div className="media-action">
          {(((props.resource.type === WorkshopSectionContentType.VIDEO_URL ||
            props.resource.type === WorkshopSectionContentType.FILE_URL ||
            props.resource.type === WorkshopSectionContentType.IMAGE_URL) &&
            props.resource.content.length > 0 &&
            !props.fileNotSelected) ||
            props.resource.type === WorkshopSectionContentType.URL ||
            props.resource.type === WorkshopSectionContentType.TEXT) &&
            props.resource.mode === "EDIT" &&
            props.resource.content &&
            !loading && (
              <button
                className={props.uploading ? "btn-disable" : "btn-add"}
                onClick={() => {
                  if (!props.uploading && !loading)
                    activePreviewMode(props.resource);
                }}
              >
                <MdCheck />
              </button>
            )}
          {props.resource.mode !== "EDIT" && (
            <button
              className={props.uploading ? "btn-disable" : "btn-edit"}
              onClick={() => {
                if (!props.uploading)
                  workshop.updateResource(workshop.selectedSubSection, {
                    ...props.resource,
                    mode: "EDIT",
                  });
              }}
            >
              <FaPencilAlt />
            </button>
          )}
          {props.resource.mode === "EDIT" ? (
            <button
              className={props.uploading ? "btn-disable" : "btn-delete"}
              onClick={() => {
                if (!props.uploading) {
                  // workshop.updateResource(workshop.selectedSubSection, {
                  //   ...props.resource,
                  //   mode: "PREVIEW",
                  // });
                  workshop.discardResourceData(
                    workshop.selectedSubSection,
                    props.resource
                  );
                }
              }}
            >
              <MdClose />
            </button>
          ) : (
            <button
              className={props.uploading ? "btn-disable" : "btn-delete"}
              onClick={() => {
                if (!props.uploading)
                  workshop.removeResource(
                    workshop.selectedSubSection,
                    props.resource
                  );
                props.updateCurrentAction(true, false, false);
              }}
            >
              <RiDeleteBin5Line />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaCard;
